export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_SHIFT':
         {
            return {
               ...state,
               shiftPayload: action.payload
            };
         }
      default:
         return state;
   }
}
